import React, { useState, useEffect, useRef } from "react";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import { Link } from "react-router-dom";
import axios from "axios";
import Footer from "../Footer/Footer";
import { VscCheckAll } from "react-icons/vsc";
import { CgClose } from "react-icons/cg";
import Bannar from "../../assets/default_banner.jpg";
import './Offer.css'
import StoreSkeleton from "../Store/StoreSkeleton";

const Offer = () => {
  const [offers, setOffers] = useState([]);
  const [showInquiryPopup, setShowInquiryPopup] = useState(false);
  const [productSuggestions, setProductSuggestions] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [citySuggestions, setCitySuggestions] = useState([]);
  const [searchCity, setSearchCity] = useState("");
  const [showCategorySuggestions, setShowCategorySuggestions] = useState(true);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [selectedCitySuggestion, setSelectedCitySuggestion] = useState(-1);
  const [previousCitySuggestions, setPreviousCitySuggestions] = useState([]);
  const [number, setnumber] = useState(1);
  const [pages, setPages] = useState(1);
  const [, setCityInputClicked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(true);
  const [skeleton, setSkeleton] = useState(true);

  const productSuggestionsRef = useRef(null);
  const citySuggestionsRef = useRef(null);
  const storeRef = useRef(null);

  const fetchAllOfferDetails = async () => {

    try {
      const consumerKey = process.env.REACT_APP_CONSUMER_KEY;
      const consumerSecret = process.env.REACT_APP_CONSUMER_SECRET;

      const url = `https://shop.pricefinder.in/wp-json/custom/v1/list-all-offers?per_page=10&page=${number}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Basic ${btoa(`${consumerKey}:${consumerSecret}`)}`,
        },
      });

      const vendorDetails = response.data.offers;
      setOffers(vendorDetails);
      setSkeleton(false)
      setPages(response.data.total_pages);
    } catch (error) {
      console.error("Error fetching vendor details:", error);
    }
  };

  const fetchOfferDetailsWithProductAndCity = async (product, city) => {
    try {
      const consumerKey = process.env.REACT_APP_CONSUMER_KEY;
      const consumerSecret = process.env.REACT_APP_CONSUMER_SECRET;
      let url;
      let vendorDetails = [];
      setOffers([])
      setSkeleton(true)
      if (city) {
        url = `https://shop.pricefinder.in/wp-json/custom/v1/list-offers?pro-tag=pro-${product}&city-tag=city-${city}`
      }
      else {
        url = `https://shop.pricefinder.in/wp-json/custom/v1/list-offers?pro-tag=pro-${product}`
      }
      const response = await axios.get(url, {
        headers: {
          Authorization: `Basic ${btoa(`${consumerKey}:${consumerSecret}`)}`,
        },
      });
      vendorDetails = response.data.offers
      setOffers(vendorDetails)
      setSkeleton(false)
      setnumber(response.data.current_page)
      setPages(response.data.total_pages);
    } catch (error) {
      console.error("Error fetching vendor details:", error);
    }
  };

  const fetchProductSuggestions = async (inputText) => {
    try {
      const consumerKey = process.env.REACT_APP_CONSUMER_KEY;
      const consumerSecret = process.env.REACT_APP_CONSUMER_SECRET;

      const url = `https://shop.pricefinder.in/wp-json/custom/v1/offers-input-product-tag-suggestions?input=pro-${inputText}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Basic ${btoa(`${consumerKey}:${consumerSecret}`)}`,
        },
      });

      const productDetails = response.data;
      setProductSuggestions(productDetails);
    } catch (error) {
      console.error("Error fetching product suggestions:", error);
    } finally {
      setShowCategorySuggestions(true);
    }
  };

  const fetchCitySuggestions = async (inputText) => {
    try {
      const consumerKey = process.env.REACT_APP_CONSUMER_KEY;
      const consumerSecret = process.env.REACT_APP_CONSUMER_SECRET;

      const url = `https://shop.pricefinder.in/wp-json/custom-dir/v1/offers-dir-tag-suggestions?input=pro-${inputText}`;

      const response = await axios.get(url, {
        headers: {
          Authorization: `Basic ${btoa(`${consumerKey}:${consumerSecret}`)}`,
        },
      });

      const cityDetails = response.data;
      setCitySuggestions(cityDetails);
      setPreviousCitySuggestions(cityDetails);
      setSelectedCitySuggestion(-1);
    } catch (error) {
      console.error("Error fetching city suggestions:", error);
    } finally {
      // setShowCitySuggestions(true);
    }
  };

  function handleSubmit(event) {
    event.preventDefault();
    setLoading(true);
    // Collect form data
    const formData = new FormData(event.target);

    // Create the jsonObject based on the desired format
    const jsonObject = {
      subject: `${formData.get("subject")}`,
      name: `${formData.get("name")}`,
      phone: `${formData.get("phone")}`,
      email: `${formData.get("email")}`,
      description: `${formData.get("description")}`,
    };
    fetch(
      "https://shop.pricefinder.in/wp-json/custom/v1/submit-freshdesk-ticket",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(jsonObject),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        console.error(data.message);
        setLoading(false);
        setFormLoading(false);
        // setSelectedProduct(null);
        // setinquiryPopup(false);
        // alert("Thank you for your inquiry! We will get back to you soon.");
      })
      .catch((error) => {
        console.error("Error submitting form:", error);
        setLoading(false);
      });
  }

  const handleCitySuggestionNavigation = (e) => {
    const suggestions = citySuggestions;
    const lastIndex = suggestions.length - 1;

    switch (e.key) {
      case "ArrowUp":
        e.preventDefault();
        setSelectedCitySuggestion((prevIndex) =>
          prevIndex > 0 ? prevIndex - 1 : lastIndex
        );
        break;
      case "ArrowDown":
        e.preventDefault();
        setSelectedCitySuggestion((prevIndex) =>
          prevIndex < lastIndex ? prevIndex + 1 : 0
        );
        break;
      case "Enter":
        e.preventDefault();
        if (selectedCitySuggestion !== -1) {
          const selectedSuggestionText = suggestions[selectedCitySuggestion];
          handleCitySuggestionClick(selectedSuggestionText);
        }
        break;
      default:
        break;
    }
  };

  const handleProductSuggestionClick = (suggestion) => {
    setSearchText(suggestion);
    // setIsSuggestionSelected(true);
    setShowCategorySuggestions(true);
    fetchCitySuggestions(suggestion);
    fetchOfferDetailsWithProductAndCity(suggestion);
    setCityInputClicked(false);
  };

  const handleCitySuggestionClick = (city) => {
    setSearchCity(city);
    fetchOfferDetailsWithProductAndCity(searchText, city);
    // setIsSuggestionSelected(false);
    // setShowCitySuggestions(false);
    setCityInputClicked(true);
    setCitySuggestions([]);
  };

  const handleInquiry = (vendor) => {
    setSelectedOffer(vendor);
    setShowInquiryPopup(true);
  };

  if (showInquiryPopup) {
    document.body.classList.add('active-enquiry')
  }
  else {
    document.body.classList.remove('active-enquiry')
  }

  const handleCloseClick = () => {
    setSelectedOffer(null);
    setShowInquiryPopup(false);
    setFormLoading(true);
  };

  const handleOverlayClick = (event) => {
    if (event.target.classList.contains("inquiry_overlay")) {
      handleCloseClick();
    }
  };

  useEffect(() => {
    setOffers([])
    fetchAllOfferDetails();
    setSkeleton(true)
  }, [number]);

  const handleOutsideClick = (event) => {
    if (
      // Check if the click happened outside the second input box
      (!citySuggestionsRef.current ||
        !citySuggestionsRef.current.contains(event.target)) &&
      // Check if the click happened outside the first input box
      (!productSuggestionsRef.current ||
        !productSuggestionsRef.current.contains(event.target)) &&
      // Check if the click happened outside the city input box
      (!document.getElementById("city-search-input") ||
        event.target !== document.getElementById("city-search-input"))
    ) {
      setCityInputClicked(false);
      // setIsSuggestionSelected(false);
      setProductSuggestions([]);
      setCitySuggestions([]);
    }
  };

  const searchVendor = () => {
    if (searchText === "" && searchCity === "") {
      fetchAllOfferDetails();
    }
  };

  const handleNextPage = () => {
    setnumber((prevNumber) => prevNumber + 1);
    storeRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const handlePreviousPage = (e) => {
    setnumber((prevNumber) => prevNumber - 1);
    storeRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  return (
    <>
      <div className="store_search_content" ref={storeRef}>
        <div className="store_search">
          <div className="store_search_category">
            <input
              type="search"
              placeholder="Search product..."
              value={searchText}
              onChange={(e) => {
                const inputText = e.target.value.toLowerCase();
                setSearchText(inputText);
                fetchProductSuggestions(inputText);
                // setIsSuggestionSelected(false);
                setSearchCity("")
              }}
            />
            <ul
              className="suggestions"
              ref={productSuggestionsRef}
              style={{
                display:
                  searchText && showCategorySuggestions ? "block" : "none",
              }}
            >
              {productSuggestions.map((suggestion) => (
                <li
                  key={suggestion}
                  onClick={() => {
                    handleProductSuggestionClick(suggestion);
                    setShowCategorySuggestions(false);
                  }}
                >
                  {suggestion}
                </li>
              ))}
            </ul>
          </div>
          <div className="search_city">
            <input
              type="search"
              placeholder="Search city..."
              list="cityList"
              value={searchCity}
              id="city-search-input"
              onChange={(e) => {
                const inputText = e.target.value.toLowerCase();
                setSearchCity(inputText);
                const filteredSuggestions = previousCitySuggestions.filter(
                  (suggestion) => suggestion.toLowerCase().startsWith(inputText)
                );
                setCitySuggestions(filteredSuggestions);
                // setIsSuggestionSelected(false);
              }}
              onClick={(e) => {
                const inputText = e.target.value.toLowerCase();
                setSearchCity(inputText);
                if (searchText !== "") {
                  setCitySuggestions(previousCitySuggestions);
                }
                // setIsSuggestionSelected(false);
              }}
              onKeyDown={handleCitySuggestionNavigation}
              disabled={previousCitySuggestions.length < 1}
            />
            <ul className="suggestions" ref={citySuggestionsRef}>
              {citySuggestions.map((suggestion, index) => {
                const isSelected = index === selectedCitySuggestion;
                return (
                  <li
                    onClick={() => handleCitySuggestionClick(suggestion)}
                    key={suggestion}
                    className={isSelected ? "selected" : ""}
                  >
                    {suggestion}
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="store_search_button" onClick={searchVendor}>
            <span>
              <svg
                width="25"
                height="25"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z"></path>
                <path d="m21 21-6-6"></path>
              </svg>
            </span>
          </div>
        </div>
      </div>
      <div className="stores">
        <div className="store__list">
          {skeleton && <StoreSkeleton store={6} />}
          {offers.map((offer, index) => (
                        <div className="store">
                            <div
                                className="store_banner"
                                style={{
                                    backgroundImage: `url(${offer.featured_image_url || Bannar
                                        })`,
                                }}
                            >
                                <div className="store_banner_content">
                                    <div className="store_title">
                                        {offer.post_id && (<Link
                                            to={`/offer/${offer.post_title.toLowerCase().replace(/\s+/g, '')}`} state={{ offId: offer.post_id }}
                                            style={{ textDecoration: "none", color: "#000" }}
                                        >{offer.post_title ? (<span className="store__title">{offer.post_title}</span>) : (<span className="store__title">{offer.vendor_display_name}</span>)}
                                        </Link>)}
                                    </div>
                                    <h2 className="store_author">{offer.author_name}</h2>
                                </div>
                            </div>
                            <div className="store_visit">
                                <span onClick={() => handleInquiry(offer)}>
                                    <div className="inquiry_btn">
                                        <AiOutlineQuestionCircle />
                                        Inquiry
                                    </div>
                                </span>
                                {offer.post_id && (<Link to={`/offer/${offer.post_title.toLowerCase().replace(/\s+/g, '')}`} state={{ offId: offer.post_id }}>
                                    <div className="visit">VISIT</div>
                                </Link>)}
                            </div>
                            {offer.vendor_logo && <div className="store_logo">
                                <img src={offer.vendor_logo} alt="logo" />
                            </div>}
                        </div>
                    ))}
          {showInquiryPopup && selectedOffer && (
            <div className="inquiry_overlay" onClick={handleOverlayClick}>
              <div className="inquiry_popup">
                <div className="popup__header">
                  <div className="popup__product">
                    <h3>{selectedOffer.author_name}</h3>
                  </div>
                  <button className="close_button" onClick={handleCloseClick}>
                    <CgClose />
                  </button>
                  {selectedOffer.featured_image_url !== "" && <div className="product__logo">
                    <img src={selectedOffer.featured_image_url} alt="" />
                  </div>}

                </div>

                {formLoading && (
                  <div className="heading_close">
                    <div className="heading_popup">
                      <h4>Ask a Question</h4>
                    </div>
                  </div>
                )}
                {formLoading ? (
                  <form onSubmit={handleSubmit} method="POST" className="form">
                    <input
                      type="text"
                      name="name"
                      placeholder="Your Name (required)"
                      required
                      autoFocus
                    />
                    <input
                      type="hidden"
                      name="subject"
                      value={
                        selectedOffer.author_name
                      }
                    />
                    <div className="input__email">
                      <input
                        type="email"
                        name="email"
                        placeholder="Your Email (required)"
                        inputMode="email"
                        required
                      />
                      <input
                        type="phone"
                        name="phone"
                        placeholder="Phone Number (required)"
                        required
                        inputMode="tel"
                      />
                    </div>
                    <textarea
                      type="text"
                      className="textarea"
                      name="description"
                      required
                      placeholder="Your Message (required)"
                    ></textarea>
                    <div className="h-captcha" data-captcha="true"></div>
                    <button type="submit" disabled={loading}>
                      {loading ? "SENDING..." : "SEND"}
                    </button>
                  </form>
                ) : (
                  <div className="thankyou__message">
                    <div className="icon">
                      <VscCheckAll />
                    </div>
                    <p>
                      Thank you for your inquiry! We will get back to you soon.
                    </p>
                    <button
                      className="btn btn-success center"
                      onClick={handleCloseClick}
                    >
                      Close
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        <div className="navigation_button">
          <div className="page_nav">
            {number > 1 && pages > 1 ? (
              <button
                className="btn btn-info button_previous"
                onClick={handlePreviousPage}
              >
                Previous
              </button>
            ) : (
              <button className="btn btn-info button_previous disabled">
                Previous
              </button>
            )}
            <span className="page__number">
              {number} of {pages}
            </span>
            {pages > number ? (
              <button
                className="btn btn-info button_next"
                onClick={handleNextPage}
              >
                Next
              </button>
            ) : (
              <button className="btn btn-info button_next disabled">
                Next
              </button>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Offer;
